// @ts-check

/**
 *  Global trigger function for GTM or Local Scripts
 * @param {"sticky" | "inline"} mode - Determines how the survey is displayed. "sticky" for a fixed position, "inline" to inject within page content.
 * @param {string} surveyType - The ID of the <template> element containing the survey HTML.
 * @param {string} targetSelector - CSS selector for where to inject the survey when mode is "inline". Ignored for "sticky" mode.
 */
// @ts-expect-error - Is not defined in window by default, but we are attaching it here for global access
window.triggerCesSurvey = function (
  mode = "sticky",
  surveyType = "",
  targetSelector = "",
) {
  const templateElement = document.getElementById(surveyType);
  if (!templateElement || !(templateElement instanceof HTMLTemplateElement)) {
    return;
  }

  // Clone the HTML from the CMS-driven template
  const content = templateElement.content.cloneNode(true);

  // Wrap it in a container
  const wrapper = document.createElement("div");
  wrapper.className = `ces-wrapper ces-${mode}`;
  wrapper.appendChild(content);

  // Inject into DOM
  if (mode === "inline" && targetSelector) {
    document.querySelector(targetSelector)?.appendChild(wrapper);
  } else {
    document.body.appendChild(wrapper);
  }
};

const CES_FORM_API_URL =
  "https://public-eur.mkt.dynamics.com/api/v1.0/orgs/1dcd030f-bdc5-4299-b62d-9bbb52e722ef/landingpageforms";

/**
 * @param {string} formSelector - CSS selector for the form to capture
 * @param {string} ciFormId - The ID of the form in Dynamics CI Form Capture
 * @param {object} mappings - Field mappings for form serialization
 * @param {function} onSuccess - Callback function to execute on successful submission
 */
// @ts-expect-error - Is not defined in window by default, but we are attaching it here for global access
window.initCesFormCapture = function (
  formSelector,
  ciFormId,
  mappings,
  onSuccess,
) {
  // @ts-expect-error - Assuming d365mktformcapture is available globally from the included script
  d365mktformcapture.waitForElement(formSelector).then((form) => {
    let submitted = false;

    form.addEventListener(
      "submit",
      (e) => {
        if (submitted) {
          return;
        }

        // Disable submit buttons to prevent multiple submissions while processing
        form
          .querySelectorAll('button[type="submit"], input[type="submit"]')
          .forEach((btn) => {
            btn.disabled = true;
          });

        // @ts-expect-error - Assuming d365mktformcapture is available globally from the included script
        const serializedForm = d365mktformcapture.serializeForm(form, mappings);
        // console.log(JSON.stringify(serializedForm)); // NOTE: enable for debugging
        const payload = serializedForm.SerializedForm.build();
        const captureConfig = {
          FormId: ciFormId,
          FormApiUrl: CES_FORM_API_URL,
        };
        // @ts-expect-error - Assuming d365mktformcapture is available globally from the included script
        d365mktformcapture
          .submitForm(captureConfig, payload)
          .then((response) => {
            // submissionStatus 0 = queued/pending - this is the expected immediate response
            // from the async Dynamics API. Treat empty errorMessage as success.
            if (response?.errorMessage) {
              //console.log("submission rejected - " + response.errorMessage);

              // Re-enable submit buttons to allow user to try again after a failure
              form
                .querySelectorAll('button[type="submit"], input[type="submit"]')
                .forEach((btn) => {
                  btn.disabled = false;
                });
            } else {
              submitted = true;
              if (typeof onSuccess === "function") onSuccess(form);
            }
          })
          .catch((error) => {
            form
              .querySelectorAll('button[type="submit"], input[type="submit"]')
              .forEach((btn) => {
                btn.disabled = false;
              });
            //console.log("submission failed - " + JSON.stringify(error));
          });
      },
      true,
    );
  });
};
